import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOMeta from '@/components/feature/SEOMeta';
import Hero from './components/Hero';
import LiveMatches from './components/LiveMatches';
import HotEvents from './components/HotEvents';
import Categories from './components/Categories';
import LatestNews from './components/LatestNews';
import CTASection from './components/CTASection';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'bb体育 - 官方体育平台',
    description: 'bb体育是您首选的专业体育平台，提供全面的体育赛事资讯、实时比分、赛事直播及体育竞技服务。',
    url: 'https://www.bbty.com',
    isPartOf: {
      '@type': 'WebSite',
      name: 'bb体育',
      url: 'https://www.bbty.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="bb体育 - 官方体育平台 | bb体育官网 赛事直播 实时比分"
        description="bb体育是您首选的专业体育平台，提供全面的体育赛事资讯、实时比分、赛事直播及体育竞技服务。bb体育汇聚全球顶级赛事，为体育爱好者打造一站式体育娱乐体验，立即加入bb体育，感受竞技魅力。"
        keywords="bb体育,bb体育官网,bb体育平台,bb体育赛事直播,bb体育实时比分,bb体育注册,bb体育app下载"
        canonicalPath="/"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <Hero />
        <LiveMatches />
        <HotEvents />
        <Categories />
        <LatestNews />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}